<template>
  <div class="component-sales-order-lines no-margin padding-top-half">
    <div class="content-all-filters">
      <!-- Lineas Pedido Venta Filter -->
      <div class="content-filter padding-half">
        <div>
          <UCDatePicker
            id="1"
            @onchange="ChangedDateQuery"
          />
        </div>
        <f7-button
          color="orange"
          :class="pendientes ? 'button-fill' : 'button-outline'"
          @click="QueryParametersPendientes()"
        >
          {{ $t('commercialization.picking.selectLine.info.btnPending') }}
        </f7-button>
        <f7-button
          color="green"
          :class="completos ? 'button-fill' : 'button-outline'"
          @click="QueryParametersCompleted()"
        >
          {{ $t('commercialization.picking.selectLine.info.btnCompleted') }}
        </f7-button>
      </div>
      <div class="content-filter-search padding-horizontal-half padding-bottom-half">
        <UCSearch
          :placeholder="$t('searchEntity.client.placeholder.searchByClient')"
          :min-length="0"
          :find-on-change="true"
          class="client-search"
          @change="EventClientSelected"
          @search-bar-value-changed=" EventClientSelected"
        />
        <UCSearch
          :placeholder="$t('common.references')"
          :min-length="0"
          :find-on-change="true"
          class="reference-search"
          @change="EventReferenceSelected"
          @search-bar-value-changed=" EventReferenceSelected"
        />
      </div>
    </div>

    <!-- Lineas Pedido Venta Resultados -->
    <div
      class="content-card-list"
      :class="{ 'content-card-list--no-items': listaFiltros.length === 0 }"
    >
      <UCPreload :show="showPreload" />
      <!-- <pre> {{ mainData }} </pre> -->
      <f7-card
        v-for="(item, index) in listaFiltros"
        :key="index"
        class="content-card-result"
      >
        <div @click="OrderLineSelection(item)">
          <f7-card-header>
            <div class="display-flex">
              <div :class="[item.Seleccionada === true ? 'btn-oval-naranja-12' : 'btn-oval-azulOscuro-12']" />
              <div class="padding-left-half">
                {{ `${item.LineaPedidoVenta.PedidoVenta.Serie} / ${item.LineaPedidoVenta.PedidoVenta.Numero}-${item.LineaPedidoVenta.Orden} ${item.LineaPedidoVenta.PedidoVenta.Cliente.Nombre}` }}
              </div>
            </div>
            <f7-badge>
              {{ `${item.EnvasesReservados} / ${item.CantidadEnvasesTotales}` }}
            </f7-badge>
          </f7-card-header>
          <f7-card-content class="padding-right-half padding-vertical-half">
            <div class="card-content-info">
              <div class="card-content-info__title">
                {{ item.LineaPedidoVenta.InfoProducto.Nombre }}
              </div>
              <div class="card-content-info__subtitle">
                {{ item.LineaPedidoVenta.InfoEnvase.Nombre }}
              </div>
              <div class="card-content-info__footer">
                {{ `${item.LineaPedidoVenta.InfoPale.Nombre} →` }} <span v-if="item.Marca != null"> {{ `${item.Marca.Nombre} →` }} </span>
                {{ `${$t('common.referenceShort')}: ${item.LineaPedidoVenta.PedidoVenta.Referencia}` }}
                {{ `→ ${$t('common.alias')}:` }} <span>{{ item.LineaPedidoVenta.PedidoVenta.Cliente.Alias }}</span>
              </div>
            </div>
            <div class="card-content-action">
              <img
                alt="iconOption"
                src="@/static/icons/ic_options.svg"
                class="image-options"
                @click="MostrarPopupOpcionesLineaPedido(item)"
              >
            </div>
          </f7-card-content>
        </div>
      </f7-card>
    </div>

    <f7-popup
      class="content-lineas-produccion-picking-popup"
      :opened="popupMostrarPopupOpcionesLineaPedido"
      @popup:closed="popupMostrarPopupOpcionesLineaPedido = false"
    >
      <f7-page>
        <TheNavbar
          :nav-title="$t('production.selectOrderLinePopup.title')"
          :popup-close-btn-enable="true"
          :style="appTheme"
        />
        <div class="padding-horizontal padding-top-half">
          <div
            v-for="(item, index) in listaPopup"
            :key="index"
            class="content-lineas-produccion-picking-popup-list"
          >
            <div class="content-lineas-produccion-picking-popup-list__item">
              <div class="content-lineas-produccion-picking-popup-list__item--title">
                {{ $t('common.shippingAddress') }}
              </div>
              <div class="content-lineas-produccion-picking-popup-list__item--subtitle">
                {{ item.DireccionEnvio.Direccion }}
              </div>
            </div>
            <div class="content-lineas-produccion-picking-popup-list__item">
              <div class="content-lineas-produccion-picking-popup-list__item--title">
                {{ $t('common.netWeight') }}
              </div>
              <div class="content-lineas-produccion-picking-popup-list__item--subtitle">
                {{ item.PesoNeto }}
              </div>
            </div>
            <div class="content-lineas-produccion-picking-popup-list__item">
              <div class="content-lineas-produccion-picking-popup-list__item--title">
                {{ $t('common.grossWeight') }}
              </div>
              <div class="content-lineas-produccion-picking-popup-list__item--subtitle">
                {{ item.PesoBruto }}
              </div>
            </div>
            <div class="content-lineas-produccion-picking-popup-list__item">
              <div class="content-lineas-produccion-picking-popup-list__item--title">
                {{ $t('common.packagesPerPallet') }}
              </div>
              <div class="content-lineas-produccion-picking-popup-list__item--subtitle">
                {{ item.EnvasesPorPalet }}
              </div>
            </div>
            <div class="content-lineas-produccion-picking-popup-list__item">
              <div class="content-lineas-produccion-picking-popup-list__item--title">
                {{ $t('common.deliveryDate') }}
              </div>
              <div class="content-lineas-produccion-picking-popup-list__item--subtitle">
                {{ FormatDate(item.FechaEntrega) }}
              </div>
            </div>
          </div>
        </div>
      </f7-page>
    </f7-popup>
  </div>
</template>

<script>
import TheNavbar from '@/components/TheNavbar.vue';
import { LogDetails as Log } from '@/js/common/HIDebuggingSupport';
import ConexionTA from '@/js/services/traceability/APITraceability';
import { HiNotification } from '@/js/common/HINotificationSupport';
import UCSearch from '@/components/common/UCSearch.vue';
import UCDatePicker from '@/components/common/UCDatePicker.vue';
import SoporteFechaYHora from '@/js/common/HIConversionSupport';
import UCPreload from '@/components/common/UCPreload.vue';

export default {
  name: 'PCSeleccionLineasPedidoVenta',
  components: {
    TheNavbar,
    UCDatePicker,
    UCSearch,
    UCPreload,
  },

  emits: [
    'resetReservation',
    'orderLineSelection',
  ],

  data() {
    return {
      pendientes: true,
      completos: false,
      lineaPedidoSeleccionada: [], // tarjeta que seleccionamos
      mainData: [],
      listaFiltros: [], // Lista de los filtros
      listaPopup: [], // lista para mostrar en el Popup
      optionsSelected: false, // Para solo mostrar el Popup o las Cantidades reservadas por Linea
      popupMostrarPopupOpcionesLineaPedido: false, // Para mostrar el popup
      showPreload: false,
      dateQuery: null,
      statusRequestTypes: {
        SINRESERVA: 0, // No hay ninguina cantidad reservada
        PARCIALMENTERESERVADO: 1, // Hay alguna cantidad reservada pero no la totalidad
        TOTALMENTERESERVADO: 2, // Se ha reservado la cantidad pedida totalmente
        NOTOTALMENTERESERVADO: 3, // Es la unión de Sin Reserva y Parcialmente Reservado.
        TODOS: 4, // Es la unión de Sin Reserva Parcialmente Reservado y Total mente reservado.
      },
      statusRequest: 0,
    };
  },

  computed: {
    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-plum-shadow)',
        '--f7-navbar-text-color': '#fff',
      };
    },
  },
  created() {
    this.StartComponent();
  },

  methods: {
    StartComponent() {
      Log(this, this.StartComponent.name);
      this.statusRequest = this.statusRequestTypes.NOTOTALMENTERESERVADO;
      const dateNow = new Date();
      this.dateQuery = `${dateNow.getFullYear()}/${dateNow.getMonth() + 1}/${dateNow.getDate()}`;
      const filter = [];
      filter.push({
        FechaConsulta: this.dateQuery,
        EstadoLineaPedido: this.statusRequest,
      });
      this.GetMainData(filter);
    },
    /** @public */
    ClearElementSelected() {
      Log(this, this.ClearElementSelected.name);
      this.OrderLineSelection(null);
    },
    GetMainData(filter) {
      Log(this, this.GetMainData.name);
      this.mainData = [];
      this.GETDataSalesOrderLine(JSON.stringify(filter));
    },
    ChangedDateQuery(newValue) {
      Log(this, this.ChangedDateQuery.name);
      const stringDate = `${newValue.getFullYear()}/${newValue.getMonth() + 1}/${newValue.getDate()}`;
      this.dateQuery = stringDate;
      const filter = [];
      filter.push({
        FechaConsulta: this.dateQuery,
        EstadoLineaPedido: this.statusRequest,
      });
      this.GetMainData(filter);
    },

    //* ************************ FILTROS  ************************** */
    EventClientSelected(val) {
      Log(this, this.EventClientSelected.name);
      if (val != null) {
        this.listaFiltros = this.mainData;
        this.FilterClient(val);
      } else {
        this.listaFiltros = null;
      }
    },

    FilterClient(filter) {
      Log(this, this.FilterClient.name);
      if (filter === '') {
        this.listaFiltros = this.mainData;
      } else {
        this.listaFiltros = this.listaFiltros.filter((e) => e.LineaPedidoVenta != null
          && e.LineaPedidoVenta.PedidoVenta.Cliente.Nombre.toString().toLowerCase().includes(filter.toLowerCase()));
      }
    },

    EventReferenceSelected(val) {
      Log(this, this.EventReferenceSelected.name);
      if (val != null) {
        this.listaFiltros = this.mainData;
        this.FilterReferencies(val);
      } else {
        this.listaFiltros = null;
      }
    },
    ResetConsultReservations() {
      this.$emit('resetReservation');
    },
    FilterReferencies(filter) {
      Log(this, this.FilterReferencies.name);
      if (filter === '') {
        this.listaFiltros = this.mainData;
      } else {
        this.listaFiltros = this.listaFiltros.filter((e) => e.LineaPedidoVenta != null
          && e.LineaPedidoVenta.PedidoVenta.Referencia.toString().toLowerCase().includes(filter.toLowerCase()));
      }
    },

    //* ************************** BOTONES ********************************** */
    QueryParametersPendientes() {
      Log(this, this.QueryParametersPendientes.name);
      this.pendientes = true;
      this.completos = false;
      this.statusRequest = this.statusRequestTypes.NOTOTALMENTERESERVADO;
      this.ResetConsultReservations();
      const filter = [];
      filter.push({
        FechaConsulta: this.dateQuery,
        EstadoLineaPedido: this.statusRequest,
      });
      this.GetMainData(filter);
    },

    QueryParametersCompleted() {
      Log(this, this.QueryParametersCompleted.name);
      this.pendientes = false;
      this.completos = true;
      this.statusRequest = this.statusRequestTypes.TOTALMENTERESERVADO;
      this.ResetConsultReservations();
      const filter = [];
      filter.push({
        FechaConsulta: this.dateQuery,
        EstadoLineaPedido: this.statusRequest,
      });
      this.GetMainData(filter);
    },

    //* **************************************************************************************** */
    ChangedDateFilter(newDateValue) {
      Log(this, this.ChangedDateFilter.name);
      this.activityList = this.activityListOrigin;
      this.activityList = this.activityList.filter((e) => e.FechaInicio.includes(newDateValue));
    },

    OrderLineSelection(value) {
      Log(this, this.OrderLineSelection.name);
      if (value === null) {
        this.$emit('orderLineSelection', null);
        this.listaFiltros.forEach((f) => {
          f.Seleccionada = false;
        });
        return;
      }
      if (!this.optionsSelected) {
        this.listaFiltros.forEach((f) => {
          f.Seleccionada = false;
        });

        const foundItem = this.listaFiltros.find((lpv) => lpv.LineaPedidoVenta.Id === value.LineaPedidoVenta.Id);

        if (foundItem) {
          foundItem.Seleccionada = true;
        }

        this.$emit('orderLineSelection', value);
      }
      this.optionsSelected = false;
    },

    //* *************************** POPUP **************************************** */
    MostrarPopupOpcionesLineaPedido(items) {
      Log(this, this.MostrarPopupOpcionesLineaPedido.name);
      this.optionsSelected = true;
      this.lineaPedidoSeleccionada = items;

      const tempExisteciaLinea = this.ObtenerLineaPedido(this.lineaPedidoSeleccionada);

      if (tempExisteciaLinea != null) {
        this.popupMostrarPopupOpcionesLineaPedido = true;
        this.listaPopup = [];

        const tempListaPopup = [];

        tempListaPopup.push({
          DireccionEnvio: tempExisteciaLinea[0].LineaPedidoVenta.PedidoVenta.DireccionEnvio,
          PesoNeto: tempExisteciaLinea[0].LineaPedidoVenta.PesoNeto,
          PesoBruto: tempExisteciaLinea[0].LineaPedidoVenta.PesoBruto,
          EnvasesPorPalet: tempExisteciaLinea[0].LineaPedidoVenta.EnvasesPorPalet,
          FechaEntrega: tempExisteciaLinea[0].LineaPedidoVenta.FechaPrevistaEntrega,
        });

        this.listaPopup = tempListaPopup;
      }
    },

    ObtenerLineaPedido(LineaSeleccionada) {
      Log(this, this.ObtenerLineaPedido.name);
      const tempLineaPedido = this.mainData.filter((t) => t.LineaPedidoVenta.Id === LineaSeleccionada.LineaPedidoVenta.Id);
      if (tempLineaPedido !== undefined) {
        return tempLineaPedido;
      }

      return null;
    },

    async GETDataSalesOrderLine(filter) {
      Log(this, this.GETDataSalesOrderLine.name);
      this.listaFiltros = [];
      this.showPreload = true;
      const result = await ConexionTA.callObtenerLineasPedidoVentaParaPicking(filter);
      if (result.Valor) {
        this.mainData = JSON.parse(result.Mensaje);
        this.listaFiltros = this.mainData;
      } else {
        HiNotification.Toast(result.Mensaje || this.$t('production.info.couldNotQuerySalesOrderInformation'));
      }
      this.showPreload = false;
    },
    FormatDate(value) {
      return `${SoporteFechaYHora.obtenerDDMMAA(value)}`;
    },
  },
};
</script>

<style lang="scss">
.component-sales-order-lines {
  --available-viewport-height: calc(100vh - var(--information-bar-height));

  --search-input-height: 36px;
  --search-input-color: var(--his-dark-blue);
  --search-input-font-size: 16px;
  --search-input-padding: 0 8px;

  --date-picker-input-height: 36px;
  --date-picker-input-color: var(--his-dark-blue);
  --date-picker-input-font-size: 16px;
  --date-picker-input-padding: 0 8px;

  background: #ebecf0;

  .button-fill {
    color: #fff;
  }

  .button-outline.color-orange {
    color: var(--his-mandarina);
    --f7-theme-color: var(--his-mandarina);

    background-color: #eddec6;
  }

  .button-outline.color-green {
    color: var(--his-green);
    background-color: #d7e5d4;
  }

  .content-all-filters {
    .content-filter {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-column-gap: 10px;

      .content-search-input {
        min-width: 180px;
      }
    }

    .content-filter-search {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-column-gap: 10px;

      .client-search {
        min-width: 230px;
      }
    }
  }

  .content-card-list {
    height: calc(var(--available-viewport-height) - 170px);
    overflow-y: scroll;

    &--no-items {
      overflow-y: unset;
    }
  }

  .content-card-result {
    .card-header {
      --f7-card-header-min-height: 36px;
      --f7-card-header-padding-horizontal: 8px;
      --f7-card-header-font-weight: 400;
    }

    .card-content {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .card-content-info {
        &__title {
          color: #172b4d;
          font-size: 18px;
          font-weight: 400;
        }

        &__subtitle {
          color: var(--his-kiwi-pulp);
          font-size: 16px;
          font-weight: 400;
        }

        &__footer {
          color: var(--his-darkgray);
          font-size: 12px;
          font-weight: 400;
          margin-top: 10px;
        }
      }

      .card-content-action {
        display: flex;
        align-self: flex-start;
        cursor: pointer;
      }
    }
  }
}

.content-lineas-produccion-picking-popup {
  --f7-navbar-title-font-size: 18px;

  background: #fff;
}

.content-lineas-produccion-picking-popup-list {
  &__item {
    display: flex;
    flex-direction: column;

    &--title {
      color: #172b4d;
      font-size: 18px;
      font-weight: 500;
      margin-top: 15px;
      text-transform: uppercase;
    }

    &--subtitle {
      color: var(--his-darkgray);
      font-size: 14px;
      font-weight: 400;
      margin-top: 5px;
    }
  }
}

.btn-oval-azulOscuro-12 {
  background-color: var(--his-steel-blue);
  box-shadow: 0 4px 8px 0 rgb(42 55 71 / 15%);
  border: 1px solid var(--his-steel-blue);
  border-radius: 17px;
  width: 12px;
  height: 12px;
  min-height: 12px;
  min-width: 12px;
  align-self: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.btn-oval-naranja-12 {
  background-color: var(--his-mandarina);
  box-shadow: 0 4px 8px 0 rgb(42 55 71 / 15%);
  border: 1px solid #db921c;
  border-radius: 17px;
  width: 12px;
  height: 12px;
  min-height: 12px;
  min-width: 12px;
  align-self: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
</style>
